/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_SERVER, API_SCT, API_UPLOADS } from '../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character } from '../../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [refresh, set_refresh] = useState(false);
    const [file, set_file] = useState(null);
    const [element, set_element] = useState(null);
    const [pagination_active, set_pagination_active] = useState(1);
    const [data, set_data] = useState(null);
    const [search, set_search] = useState('');
    const [tab, set_tab] = useState('user');

    const [id, set_id] = useState('');
    const [name, set_name] = useState('');
    const [username, set_username] = useState('');
    const [password, set_password] = useState('');
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _read = (pages) => {

        let action_sync;

        if(tab === 'user'){
            action_sync = 'read_user'
        }else if(tab === 'user_guest'){
            action_sync = 'read_user_guest'
        }else if(tab === 'user_demo'){
            action_sync = 'read_user_demo'
        }else{
            error('Opps')
        }

		let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (20 * pages) - 20 : 0
        
        }
        
        loading(true);

        API_GET_REQUEST('web__________?action=' + action_sync
            + '&limit=20'
            + '&offset=' + offsetSync
        , 
		).then((response) => {
            if(response.data.result == 'success'){
                console.log(JSON.stringify(response.data.data, undefined, 2))
                set_data(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _delete = (id) => {

        let action_sync;

        if(tab === 'user'){
            action_sync = 'delete_user'
        }else if(tab === 'user_guest'){
            action_sync = 'delete_user_guest'
        }else if(tab === 'user_demo'){
            action_sync = 'delete_user_demo'
        }else{
            error('Opps')
        }

		if(loading === true){
            return
        }

        loading(true);

        API_GET_REQUEST('web__________?action=' + action_sync
            + '&id=' + id
        , 
		).then((response) => {
            if(response.data.result == 'success'){
                console.log(JSON.stringify(response.data.data, undefined, 2))
                set_refresh(random_character(16))
                set_element(null)
                error(response.data.title)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _search = () => {
        
        if(search.length > 3){
    
            API_GET_REQUEST('source__________?action=search'
                + '&search=' + search
            , 
            ).then((response) => {
                if(response.data.result == 'success'){
                    // console.log(JSON.stringify(response.data.data.list, undefined, 2))
                    set_data(response.data.data)
                    error('')
                }else if(response.data.error){
                    error(response.data.error);
                    set_data(null)
                }
            })
            .catch((e) => {
                console.log('catch : ', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }

    }

    const _uploads = (action) => {

        if(loading === true){
            return
        }

        loading(true);

        var data = new FormData();
        data.append("sct", API_SCT);
        data.append("key", STORAGE_USER[0].id_key);
        data.append("action", action);
        data.append("id", id);
        data.append("name", name);
        data.append("username", username);
        data.append("password", password);

        if(file !== null){
            file.map((item) => (
                data.append("file", item)
            ))
        }else{
            data.append("sub_action", 'text');
        }

        var config = {
            method: 'post',
            url: API_SERVER + "/api/v1.0/web/user__________",
            headers: { 
                'Authorization': `Bearer ${STORAGE_TOKEN}`,
            },
            data : data,
            onUploadProgress: progressEvent => {
                console.log('loaded : ', progressEvent.loaded)
                console.log('total : ', progressEvent.total)
                if(file !== null){
                    progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
                }
            }
        };

        axios(config)
        .then((response) => {
            if(response.data.result === 'success'){
                console.log('results : ', JSON.stringify(response.data));
                set_file(null)
                set_refresh(random_character(16))
                set_element(null)
                set_name('')
                set_username('')
                set_password('')
                error(response.data.title)
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        })
        .finally(() => {
			loading(false);
		})

    }
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 2048000){
                return error('Ukuran File maxsimal 2MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        if(search.length > 0){
            _search()
        }else{
            _read()
        }

    }, [refresh, search, tab])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    return (
        <>

            <div className="_row _center_align">
                <div className="_column">
                    <h1 style={{marginBottom: 30}}><span style={{color: '#118ab2'}}>e-</span>Web User</h1>
                </div>
            </div>
            <div className="_row _center_align _push_b_d">
                <ion-icon name="leaf-outline" style={{fontSize: 20}}></ion-icon>
                <p className="_push_l_m">Kendali penuh untuk mengatur bagian User web</p>
            </div>

            <div className="_row _center_align _push_b_d">
                <div className="_column">
                    <div className="_relative">
                        <div onClick={() => {
                            if(element === 'overlay_dropdown'){
                                set_element(null)
                            }else{
                                set_element('overlay_dropdown')
                            }
                        }} className="_btn _cursor_pointer">
                            <div className="_row _center_align">
                                <div className="_column">
                                    select : {tab}
                                </div>
                                <div className="_push_l_m _push_t_t">
                                    {
                                        element === 'overlay_dropdown' ?
                                            <ion-icon name="chevron-up-outline"></ion-icon>
                                        :
                                            <ion-icon name="chevron-down-outline"></ion-icon>
                                    }
                                </div>
                            </div>
                        </div>
                        {
                            element === 'overlay_dropdown' ?
                                // _left or _right
                                <>
                                    <div className="_fmc_overlay_dropdown _left">
                                        <div onClick={() => {set_tab('user')}} className="_item">User</div>
                                        <div onClick={() => {set_tab('user_guest')}} className="_item">User Guest</div>
                                        <div onClick={() => {set_tab('user_demo')}} className="_item">User Demo</div>
                                    </div>
                                </>
                            : null
                        }
                    </div>
                </div>
                <div>                    
                    <div onClick={() => {
                        set_element('overlay')
                        set_id('')
                        set_name('')
                        set_username('')
                        set_password('')
                    }} className="_btn _cursor_pointer">
                        Tambah
                    </div>
                </div>
            </div>

            {
                element === 'overlay' ?
                    <>
                        <div className="_fmc_overlay" style={{position: 'relative', borderWidth: 1, borderColor: '#eee', borderStyle: 'solid', marginBottom: 20}}>
                            <div className="_fmc_overlay_navbar">
                                <div className="_row _center_align">
                                    <div className="_column">
                                        <p className="_font_size_18px">Uploads</p>
                                    </div>
                                    <div onClick={() => {
                                        if(element === 'overlay'){
                                            set_element(null)
                                        }else{
                                            set_element('overlay')
                                        }
                                    }} className="_push_l_d _btn _cursor_pointer">
                                        Keluar
                                    </div>
                                </div>
                            </div>
                            <div className="_fmc_overlay_content">

                                <div>
                                    <div className="_push_b_m">
                                        <div className="_relative _push_b_m">
                                            <p style={{color: '#888', fontSize: 13}}>
                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                Name
                                            </p>
                                            <div className="_e_input">
                                                <input 
                                                    placeholder=""
                                                    type={'text'} 
                                                    onChange={e => set_name(e.target.value)}
                                                    value={name}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="_push_b_m">
                                        <div className="_relative _push_b_m">
                                            <p style={{color: '#888', fontSize: 13}}>
                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                Username
                                            </p>
                                            <div className="_e_input">
                                                <input 
                                                    placeholder=""
                                                    type={'text'} 
                                                    onChange={e => set_username(e.target.value)}
                                                    value={username}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="_push_b_m">
                                        <div className="_relative _push_b_m">
                                            <p style={{color: '#888', fontSize: 13}}>
                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                Password
                                            </p>
                                            <div className="_e_input">
                                                <input 
                                                    placeholder=""
                                                    type={'password'} 
                                                    onChange={e => set_password(e.target.value)}
                                                    value={password}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        tab === 'user' ?
                                            <div className="_btn _cursor_pointer _push_r_m" onClick={() => {_uploads('user_insert_text')}}>Tambah</div>
                                        : tab === 'user_guest' ?
                                            <div className="_btn _cursor_pointer _push_r_m" onClick={() => {_uploads('user_guest_insert_text')}}>Tambah</div>
                                        : tab === 'user_demo' ?
                                            <div className="_btn _cursor_pointer _push_r_m" onClick={() => {_uploads('user_demo_insert_text')}}>Tambah</div>
                                        : null
                                    }
                                </div>
                            </div>
                        </div>
                    </>
                : null
            }

            <div className="_overflow_x">
                <table className="_table">
                    <thead>
                        <th style={{width: 60}}><ion-icon name="rocket-outline" style={{fontSize: 22}}></ion-icon></th>
                        <th>Name</th>
                        <th>Username</th>
                        <th>
                            <div className="_right_text">
                                <ion-icon name="magnet-outline" style={{fontSize: 24}}></ion-icon>
                            </div>
                        </th>
                    </thead>
                    <tbody>
                        {
                            data && data.list.map((item, index) => (
                                <>
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>
                                            {item.name}
                                        </td>
                                        <td>
                                            {item.username}
                                        </td>
                                        <td>
                                            <div className="_right_text _push_r_m">
                                                <div onClick={() => {
                                                    if(element === `update_${index}`){
                                                        set_element(null)
                                                    }else{
                                                        set_element(`update_${index}`)
                                                        set_id(item.id)
                                                        set_name(item.name)
                                                        set_username(item.username)
                                                    }
                                                }} className="_btn _cursor_pointer _push_r_m">
                                                    Update
                                                </div>
                                                <div onClick={() => {
                                                    if(element === `update_password_${index}`){
                                                        set_element(null)
                                                    }else{
                                                        set_element(`update_password_${index}`)
                                                        set_id(item.id)
                                                    }
                                                }} className="_btn _cursor_pointer _push_r_m">
                                                    Change Password
                                                </div>
                                                <div onClick={() => {
                                                    _delete(item.id)
                                                }} className="_btn _cursor_pointer">
                                                    Delete
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    {
                                        element === `update_${index}` &&
                                        <tr style={{verticalAlign: 'top'}}>
                                            <td></td>
                                            <td>
                                                <div className="_relative _push_b_m">
                                                    <p style={{color: '#888', fontSize: 13}}>
                                                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                        Name
                                                    </p>
                                                    <div className="_e_input">
                                                        <input 
                                                            placeholder=""
                                                            type={'text'} 
                                                            onChange={e => set_name(e.target.value)}
                                                            value={name}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="_relative _push_b_m">
                                                    <p style={{color: '#888', fontSize: 13}}>
                                                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                        Username
                                                    </p>
                                                    <div className="_e_input">
                                                        <input 
                                                            placeholder=""
                                                            type={'text'} 
                                                            onChange={e => set_username(e.target.value)}
                                                            value={username}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="_right_text _push_r_m">
                                                    <div onClick={() => {
                                                        {
                                                            tab === 'user' ?
                                                                _uploads('user_update_text')
                                                            : tab === 'user_guest' ?
                                                                _uploads('user_guest_update_text')
                                                            : tab === 'user_demo' ?
                                                                _uploads('user_demo_update_text')
                                                            : null
                                                        }
                                                    }} className="_btn _cursor_pointer">
                                                        Simpan
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                    {
                                        element === `update_password_${index}` &&
                                        <tr style={{verticalAlign: 'top'}}>
                                            <td></td>
                                            <td colspan="2">
                                                <div className="_relative _push_b_m">
                                                    <p style={{color: '#888', fontSize: 13}}>
                                                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                        Password
                                                    </p>
                                                    <div className="_e_input">
                                                        <input 
                                                            placeholder=""
                                                            type={'password'} 
                                                            onChange={e => set_password(e.target.value)}
                                                            value={password}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="_right_text _push_r_m">
                                                    <div onClick={() => {
                                                        {
                                                            tab === 'user' ?
                                                                _uploads('user_update_password_text')
                                                            : tab === 'user_guest' ?
                                                                _uploads('user_guest_update_password_text')
                                                            : tab === 'user_demo' ?
                                                                _uploads('user_demo_update_password_text')
                                                            : null
                                                        }
                                                    }} className="_btn _cursor_pointer">
                                                        Simpan
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                </>
                            ))
                        }
                    </tbody>
                </table>
            </div>

            {/* <div className="_row _center_align">
                <div className="_column">

                </div>
                <div className="_column">
                    
                </div>
            </div> */}
            
            <div className="_lily_pad_h_d _push_b_d _push_t_d">
                <div className="__pagination">
                    {
                        data&&data.pages.map((item, index) => {
                            if(data.pages.length > 1){
                                return (

                                    <div 
                                        key={index} 
                                        className="__item"
                                        style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                        onClick={() => {
                                            _read(index + 1);
                                            set_pagination_active(index + 1)
                                        }}
                                    >
                                        <div className="_position_middle">
                                            {item}
                                        </div>
                                    </div>
                                    
                                )
                            }
                        })
                    }
                </div>
            </div>

            <div style={{height: 100}}></div>

        </>
    );

}

export default Screen;